
import Api from '@/utils/api';
import url from 'url';
import qs from 'qs';
import MHeader from '../Header/Header.vue';
import store from '../../store/index.js'
import LocalStore from '@/utils/localStore';
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


import Swiper from '../Detail/Swiper.vue'
export default {
components: {
MHeader,
XInput,
Group,
XButton,
Cell,
'm-swiper': Swiper
},
data() {
return {
mobileNumber: "",
smsCode: "",
countingNumber: 0,
product: {},
productImage: ''
}
},
created() {
const fullPath = this.$route.query.fullPath
if (fullPath) {
if (fullPath.startsWith('/Detail/')) {
const parsedUrl = url.parse(fullPath)
const query = qs.parse(parsedUrl.query)

const pid = parsedUrl.pathname.substr('/Detail/'.length)

Api.getProductDetail(pid)
.then(res => {
this.product = res.data
if (this.product.images && this.product.images[0]) {
this.productImage = this.product.images[0]
}
wx.ready(() => {
let title = this.product.title
if (this.product.specLabel) {
title += '(' + this.product.specLabel + ')'
}
wx.onMenuShareAppMessage({
title: title,
desc: this.product.subTitle,
link: location.href,
imgUrl: this.UPLOAD_DOMAIN + this.product.thumbnail,
success: function () {
}
})
wx.onMenuShareTimeline({
title: title,
desc: this.product.subTitle,
link: location.href,
imgUrl: this.UPLOAD_DOMAIN + this.product.thumbnail,
success: function () {
}
})
})
})
}
}
},
methods: {
sendSMSCode() {
if (!this.mobileNumber) {
this.$vux.toast.text('请输入手机号码')
return
}
Api.sendLoginSMSCode({
mobileNumber: this.mobileNumber
}).then(res => {
this.$store.commit('updateToast', {
show: true,
text: '短信验证码发送成功, 5分钟内有效!'
});
this.countingNumber = 60
let self = this;
let timer = null;
if (self && !self._isDestroyed) {
timer = setInterval(() => {
if (self && !self._isDestroyed) {
this.countingNumber--
if (this.countingNumber < 1) {
clearInterval(timer)
}
}
}, 1000);
}
})
.catch((e) => {
this.$vux.toast.text('短信发送失败')
})
},
smsLogin() {
if (!this.mobileNumber) {
this.$vux.toast.text('请输入手机号码')
return
}
if (!this.smsCode) {
this.$vux.toast.text('请输入验证码')
return
}
Api.smsLogin({
mobileNumber: this.mobileNumber,
smsCode: this.smsCode
}).then(res => {
LocalStore.setToken(res.data.jwtToken)
LocalStore.setUser(res.data.user)
store.commit('updateUserInfo', res.data.user)
this.$store.dispatch('loadUserInfo')
.then(() => {
this.$store.commit('updateToast', {
show: true,
text: '登录成功'
});
if (this.$route.query.fullPath) {
this.$router.replace(this.$route.query.fullPath)
} else {
this.$router.replace('/')
}
})
})
.catch((e) => {
this.$vux.toast.text('登录失败')
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Login/smsLogin.vue